import { cn, Typography } from '@prenuvo/halo';

export interface CharacterLimitIndicatorProps {
  currentLength: number;
  isActive: boolean;
  maxLength: number;
}

export function CharacterLimitIndicator({
  currentLength,
  isActive,
  maxLength,
}: CharacterLimitIndicatorProps) {
  if (!isActive) {
    return null;
  }

  const remainingCharacters = Math.max(0, maxLength - currentLength);
  const hasReachedLimit = remainingCharacters === 0;

  return (
    <Typography
      as="p"
      className={cn('mt-1 text-right text-xs', {
        'text-neutral-400!': !hasReachedLimit,
        'text-red-500! dark:text-red-500!': hasReachedLimit,
      })}
      translationKey="FCT.REPORTING.CHARACTER_LIMIT.REMAINING"
      values={{ count: remainingCharacters }}
      variant="paragraph-xs"
    />
  );
}
